import { Flex, Tabs, TabList, Tab, TabPanels, TabPanel, TabIndicator, Box } from '@chakra-ui/react';
import withAuth from '@/HOCs/withAuth';
import { useSearchParams } from 'react-router-dom';
import { useState, useEffect, useCallback, useMemo } from 'react';

import CustomerReviews from './CustomerReviews';
import AdminReview from '@/components/AdminReview/AdminReview';

const Reviews = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  // Get initial tab from URL (?tab=admin → index 1, otherwise 0)
  const getInitialTabIndex = useCallback(() => {
    return searchParams.get('tab') === 'admin' ? 1 : 0;
  }, [searchParams]);

  // Sync selected tab with URL
  const handleTabChange = useCallback(
    (index: number) => {
      setSelectedTabIndex(index);

      const newParams = new URLSearchParams(searchParams);
      if (index === 1) {
        newParams.set('tab', 'admin');
      } else {
        newParams.delete('tab');
      }
      setSearchParams(newParams, { replace: true });
    },
    [searchParams, setSearchParams],
  );

  // Initialize tab index from URL on mount or when searchParams change
  useEffect(() => {
    setSelectedTabIndex(getInitialTabIndex());
  }, [getInitialTabIndex]);

  // Tab configuration
  const tabs = useMemo(
    () => [
      {
        label: 'Customer Reviews',
        content: () => <CustomerReviews />,
      },
      {
        label: 'Admin Review',
        content: () => <AdminReview />,
      },
    ],
    [],
  );

  return (
    <Flex pt={6} direction="column" width="100%" fontFamily="primary">
      <Tabs index={selectedTabIndex} onChange={handleTabChange} colorScheme="brand.primary" px={6}>
        <TabList
          justifyContent="start"
          gap={5}
          width="100%"
          borderBottom="1px solid"
          borderColor="gray.200"
        >
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              width="fit-content"
              fontSize="sm"
              fontWeight="semibold"
              color="text.primary"
              _selected={{ color: 'brand.primary.DEFAULT' }}
              _hover={{ color: 'brand.primary.DEFAULT' }}
              pb={3}
            >
              {tab.label}
            </Tab>
          ))}
        </TabList>

        <TabIndicator mt="-1.5px" height="2px" bg="brand.primary.DEFAULT" borderRadius="1px" />

        <TabPanels bg="background.secondary" minH="600px">
          {tabs.map((tab, index) => (
            <TabPanel key={index} px={0} py={4}>
              <Box display={selectedTabIndex === index ? 'block' : 'none'}>{tab.content()}</Box>
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Flex>
  );
};

export default withAuth(Reviews);
